import { DateTime } from "luxon"

import { type OpeningHour } from "@/utils/opening_hours"

import { getSidebarOpeningRange } from "./reservation_sidebar_availability"

type ClosingGuardInput = {
  date: DateTime | null
  startTime: string | null
  durationSeconds: number | null
  openingHours?: OpeningHour[]
  timezone: string
}

/**
 * Step-1 advance gate (decision #9): the only availability check before the table screen.
 * Returns true when `startTime + durationSeconds` still lands at or before the venue's closing
 * time for `date`. Overnight venues (close < open) are handled by `getSidebarOpeningRange`, which
 * rolls `closesAt` to the following day. Returns false for missing inputs or a closed date.
 */
export const fitsWithinClosingTime = ({
  date,
  startTime,
  durationSeconds,
  openingHours,
  timezone,
}: ClosingGuardInput): boolean => {
  if (!date || !startTime || !durationSeconds || durationSeconds <= 0) return false

  const openingRange = getSidebarOpeningRange(date, openingHours, timezone)
  if (!openingRange) return false

  const start = DateTime.fromISO(startTime, { zone: timezone })
  if (!start.isValid) return false

  const end = start.plus({ seconds: durationSeconds })

  return end <= openingRange.closesAt
}
